import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

interface IRegisterOfferForCoopBody {
  orgId: string;
  irrevocable: Date;
  listingId: string;
  attachmentForm801?: {
    filename: string;
    url: string;
  };
  phone: string;
}

const registerOfferForCoop = async (
  listingId: string,
  offer: IRegisterOfferForCoopBody,
) => {
  const config: AxiosRequestConfig = {
    url: `/user/coop/listing/${listingId}/offer`,
    method: 'post',
    data: offer,
  };

  const { data } = await axios.request<void>(config);

  return data;
};

export default registerOfferForCoop;
